import React from 'react'

const LegalLiEle = ({ children }) => {
  return <li style={{ paddingLeft: 8 }}>{children}</li>
}

export default LegalLiEle
